import { useEffect } from 'react'
import { runtimeEnv } from '@/utils/runtimeEnv'

const STYLE_ELEMENT_ID = 'custom-styles'
const STORAGE_KEY = 'custom-styles-cache'

const apiBase = runtimeEnv.VITE_API_BASE_URL ? `${runtimeEnv.VITE_API_BASE_URL}/api` : '/api'

function applyStyles(css: string): void {
  let styleEl = document.getElementById(STYLE_ELEMENT_ID) as HTMLStyleElement | null
  if (!styleEl) {
    styleEl = document.createElement('style')
    styleEl.id = STYLE_ELEMENT_ID
    document.head.appendChild(styleEl)
  }
  styleEl.textContent = css
}

export async function refreshCustomStyles(): Promise<void> {
  // Apply cached styles immediately so there's no flash on page load
  const cached = localStorage.getItem(STORAGE_KEY)
  if (cached !== null) {
    applyStyles(cached)
  }

  try {
    const res = await fetch(`${apiBase}/custom-styles`, { cache: 'no-store' })
    const css = await res.text()
    applyStyles(css)
    localStorage.setItem(STORAGE_KEY, css)
  } catch {
    // Offline or server unreachable — cached styles remain applied
  }
}

export function useCustomStyles(): void {
  useEffect(() => {
    refreshCustomStyles()
  }, [])
}
